import { css } from '@linaria/core';

import { MqTablet } from '~shared/ui/theme/media';

export const root = css`
	--transition-time: 0.3s;

	& [role='button'] {
		transition: opacity var(--transition-time);
		will-change: opacity;
	}

	& input:placeholder-shown + [role='button'] {
		opacity: 0;
		pointer-events: none;
	}
`;

export const shrinkable = css`
	--width: 27rem;

	${MqTablet} {
		& > :first-child {
			transform: translateX(0);
			transition: transform var(--transition-time);
			will-change: transform;
		}

		& input {
			width: var(--width) !important;
			transition: width var(--transition-time),
				border-radius var(--transition-time), padding var(--transition-time);
			will-change: width, border-radius, padding;

			&::placeholder {
				transition: opacity var(--transition-time);
				will-change: opacity;
			}
		}

		&:hover {
			--safari-hover-fix: anything-on-hover;
		}

		&:not(:is(:hover, :focus-within, :has(input:not(:placeholder-shown)))) {
			& > :first-child {
				transform: translateX(-3px);
			}

			& input {
				width: var(--input-height) !important;
				padding-right: 0 !important;
				padding-left: 0 !important;
				border-radius: var(--radius-xl);

				&::placeholder {
					opacity: 0;
				}
			}

			& [role='button'] {
				opacity: 0;
				pointer-events: none;
			}
		}
	}
`;
